import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { Transaction } from './transaction.models';

@Injectable({ providedIn: 'root' })
export class TransactionDbService extends FirestoreBase<Transaction> {
  constructor(firestore: Firestore) {
    super('transactions', firestore);
  }
}
